import React, { useEffect, useRef } from 'react';
import logo from './logo.png';
import './App.css';

function App() {
    const canvasRef = useRef<HTMLCanvasElement | null>(null);

    // Анимированное звёздное поле с параллаксом
    useEffect(() => {
        const canvas = canvasRef.current!;
        const ctx = canvas.getContext('2d')!;
        let raf = 0;

        const DPR = Math.min(window.devicePixelRatio || 1, 2);
        const starsCount = 180; // можно увеличить/уменьшить
        let stars: { x:number; y:number; z:number; s:number }[] = [];
        let w = 0, h = 0, cx = 0, cy = 0;

        function resize() {
            w = canvas.clientWidth;
            h = canvas.clientHeight;
            canvas.width = Math.floor(w * DPR);
            canvas.height = Math.floor(h * DPR);
            ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
            cx = w / 2;
            cy = h / 2;
        }

        function initStars() {
            stars = Array.from({ length: starsCount }).map(() => ({
                x: (Math.random() * 2 - 1) * w,
                y: (Math.random() * 2 - 1) * h,
                z: Math.random() * 0.6 + 0.4, // «глубина»
                s: Math.random() * 1.2 + 0.3,  // размер
            }));
        }

        let t = 0;
        function draw() {
            t += 0.006;
            ctx.clearRect(0, 0, w, h);

            // лёгкая дымка/виньетка
            const grad = ctx.createRadialGradient(cx, cy, 0, cx, cy, Math.max(w, h));
            grad.addColorStop(0, 'rgba(0,0,0,0.15)');
            grad.addColorStop(1, 'rgba(0,0,0,0.5)');
            ctx.fillStyle = grad;
            ctx.fillRect(0, 0, w, h);

            // параллакс-смещение
            const dx = Math.cos(t) * 12;
            const dy = Math.sin(t * 0.8) * 12;

            for (const star of stars) {
                const px = (star.x / star.z) + cx + dx;
                const py = (star.y / star.z) + cy + dy;

                // «хвост»
                ctx.beginPath();
                ctx.moveTo(px, py);
                ctx.lineTo(px - dx * 0.7, py - dy * 0.7);
                ctx.strokeStyle = 'rgba(100, 180, 255, 0.35)';
                ctx.lineWidth = star.s * 0.6;
                ctx.stroke();

                // звезда
                ctx.beginPath();
                ctx.arc(px, py, star.s, 0, Math.PI * 2);
                ctx.fillStyle = 'rgba(160, 220, 255, 0.85)';
                ctx.fill();

                // лёгкое мерцание
                star.z -= 0.002;
                if (star.z < 0.3) {
                    star.x = (Math.random() * 2 - 1) * w;
                    star.y = (Math.random() * 2 - 1) * h;
                    star.z = 1;
                }
            }

            raf = requestAnimationFrame(draw);
        }

        const onResize = () => { resize(); initStars(); };
        resize();
        initStars();
        draw();

        window.addEventListener('resize', onResize);
        return () => {
            cancelAnimationFrame(raf);
            window.removeEventListener('resize', onResize);
        };
    }, []);

    return (
        <div className="App">
            {/* Фоновый слой: градиентная сетка + шум */}
            <div className="bg-layers" aria-hidden />

            {/* Canvas со звёздами */}
            <canvas ref={canvasRef} className="starfield" aria-hidden />

            {/* Контентная карта */}
            <main className="card grid3">
                <div className="belt top">
                    <p className="eyebrow">Coming soon</p>
                </div>

                <div className="belt center">
                    <img src={logo} className="brand-mark" alt="Logo" />
                </div>

                <div className="belt bottom">
                    <h1 className="title">GENSOX</h1>
                    <p className="subtitle">AI Streaming Universe</p>
                    <footer className="signature">
                        <span className="quote"> “Think. Create. Stream.”</span>
                    </footer>
                </div>
            </main>
        </div>
    );
}

export default App;
